module.exports = __webpack_public_path__ + "media/project/cookie-helpdesk-6df736b7.png";